import type { BadgeColor } from '@ksyos/design-system';
import type { JSX } from 'react';
import { Badge, FormGroup } from '@ksyos/design-system';

export type ValueAndColorOption = {
    color: BadgeColor;
    value: string;
};

type FormGroupBadgeProps = Readonly<{
    label: string;
    options: ValueAndColorOption[];
    value: string | null;
}>;

export function FormGroupBadge(props: FormGroupBadgeProps): JSX.Element | null {
    const { value, label, options } = props;
    const badge = options.find((item) => item.value === value);

    if (!badge) {
        return null;
    }

    return (
        <FormGroup label={label}>
            <Badge
                color={badge.color}
                text={badge.value}
            />
        </FormGroup>
    );
}
